import { render } from "./CPieChart.vue?vue&type=template&id=7825ee00"
import script from "./CPieChart.vue?vue&type=script&lang=js"
export * from "./CPieChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__